export const barkioLocales = ["en", "cs", "de"];
export const barkioLocalesExtended = [...barkioLocales, "nl", "fr", "uk", "id", "tr"];

export const bibinoLocales = ["en", "cs", "de", "nl", "fr"];
export const bibinoLocalesExtended = [...bibinoLocales, "fil", "ko"];

export const cameritoLocales = ["en", "cs"];
export const cameritoLocalesExtended = [...cameritoLocales];

const locales = {
  barkio: barkioLocales,
  bibino: bibinoLocales,
  camerito: cameritoLocales
};

const extendedLocales = {
  barkio: barkioLocalesExtended,
  bibino: bibinoLocalesExtended,
  camerito: cameritoLocalesExtended
};

/**@argument {"barkio" | "bibino" | "camerito"} appName */
export const getLocales = (appName) => locales[appName] || [];

/**@argument {"barkio" | "bibino" | "camerito"} appName */
export const getExtendedLocales = (appName) => extendedLocales[appName] || [];
